/** Subtle highlight for invalid rows in the simple validation UI. */
export const entityListInvalidRowSimpleClassName =
  'bg-amber-50/50 dark:bg-amber-950/25';
